/* PDP redesign · Ingredients — calm-9 chip cluster interaction */

(function () {
  function initSection(root) {
    if (root.dataset.pdpIngInit) return;
    root.dataset.pdpIngInit = '1';

    const chips = Array.from(root.querySelectorAll('.pdp-ing__chip'));
    const descRole = root.querySelector('.pdp-ing__desc-role');
    const descName = root.querySelector('.pdp-ing__desc-name');
    const descBody = root.querySelector('.pdp-ing__desc-body');

    if (!chips.length || !descRole || !descName || !descBody) return;

    function select(i) {
      chips.forEach((c, idx) => c.setAttribute('aria-selected', idx === i ? 'true' : 'false'));
      const c = chips[i];
      descRole.textContent = c.dataset.role || '';
      descName.textContent = c.dataset.name || c.textContent;
      descBody.textContent = c.dataset.body || '';
    }

    chips.forEach((c, i) => c.addEventListener('click', () => select(i)));

    const initialIndex = chips.findIndex(c => c.getAttribute('aria-selected') === 'true');
    select(initialIndex === -1 ? 0 : initialIndex);
  }

  function init() {
    document.querySelectorAll('.pdp-ing').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
